import { Component, OnInit, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { Funcionalidad } from '../../_models/funcionalidad';
import { NavService } from '../../_services/_nav.service';
import { Router } from '@angular/router';
import { AutenticacionService } from '../../_services/autenticacion.service';
import { HomologacionEstado } from '../../_models/homologacion-estado';
import { HomologacionEstadoService } from '../../_services/homologacion-estado.service';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { ListaService } from '../../_services/lista.service';
import { forkJoin } from 'rxjs';
import { EstadoService } from '../../_services/estado.service';
import { ListaItem } from '../../_models/lista-item';
import { Estado } from '../../_models/estado';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component( {
  selector: 'app-homologacion-estado',
  templateUrl: 'homologacion-estado.component.html'
} )

export class HomologacionEstadoComponent implements OnInit {

  lisHomologacionTodas: HomologacionEstado[] = [];
  lisHomologacion: HomologacionEstado[] = [];
  carInformacionInicial = true;
  columnas: any[];
  busqueda: string;
  @ViewChild('dt') tabla: Table;
  menu: Funcionalidad = new Funcionalidad();
  lisEstados: SelectItem[] = [];
  lisEstadosShivam: SelectItem[] = [];
  lisFase: SelectItem[] = [];
  lisLineaCredito: SelectItem[] = [];
  formulario: FormGroup;
  submitted = false;

  constructor( private homEstadoServicio: HomologacionEstadoService,
               private navServicio: NavService,
               private router: Router,
               private lisServicio: ListaService,
               private estServicio: EstadoService,
               private fb: FormBuilder,
               private conServicio: ConfirmationService,
               private autServicio: AutenticacionService ) {
  }

  ngOnInit(): void {
    const mn = this.autServicio.obtenerFuncionalidades().find( x => x.ruta === 'apl/homologacion-estado' );
    if ( mn ) {
      this.menu = mn;
    }

    this.columnas = [
      { field: 'fase', header: this.navServicio.buscarMensaje( 'HOMOLOGACIONESTADO.LBL_FASE' ), sort: true },
      { field: 'estadoShivam', header: this.navServicio.buscarMensaje( 'HOMOLOGACIONESTADO.LBL_ESTADOSHIVAM' ), sort: true },
      { field: 'estado', header: this.navServicio.buscarMensaje( 'HOMOLOGACIONESTADO.LBL_ESTADOANALIZAMOS' ), sort: true },
      { field: 'lineaCredito', header: this.navServicio.buscarMensaje( 'HOMOLOGACIONESTADO.LBL_LINEACREDITO' ), sort: true },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];
    this.busqueda = this.navServicio.getSearch( 'homologacion-estado.component' );


    forkJoin( this.homEstadoServicio.listado(),
      this.lisServicio.getMasterDetails( 'ListasFases' ),
      this.lisServicio.getMasterDetails( 'ListasEstadosShivam' ),
      this.estServicio.listadoHabilitados(),
      this.lisServicio.getMasterDetails( 'ListasLineasCredito' ) ).subscribe( ( [ homEstados, lisFases, lisEstadosShivam, lisEstados, lisLineaCredito ] ) => {
      this.lisHomologacionTodas = homEstados;
      lisFases.map( ( s: ListaItem ) => {
        this.lisFase.push( { label: s.nombre, value: s.idLista } );
      } );
      lisEstadosShivam.map( ( s: ListaItem ) => {
        this.lisEstadosShivam.push( { label: s.nombre, value: s.idLista } );
      } );
      lisLineaCredito.map( ( s: ListaItem ) => {
        this.lisLineaCredito.push( { label: s.nombre, value: s.idLista } );
      } );
      lisEstados.map( ( s: Estado ) => {
        this.lisEstados.push( { label: s.nombre, value: s.idEstado } );
      } );
      this.cargarHabilitados();
      this.cargarFormulario();
      this.carInformacionInicial = false;
      this.filtrar();
    } );
  }

  cargarFormulario() {
    this.formulario = this.fb.group( {
      idEstado: [ null, [ Validators.required ] ],
      idEstadoShivam: [ null, [ Validators.required ] ],
      idFase: [ null, [ Validators.required ] ],
      idLineaCredito: [ null, [ Validators.required ] ],
    } );
  }

  cargarHabilitados() {
    this.lisHomologacion = this.lisHomologacionTodas.filter( x => x.indicadorHabilitado );
  }

  setBusqueda() {
    this.navServicio.setSearch( 'homologacion-estado.component', this.busqueda );
  }

  filtrar() {
    setTimeout( () => {
      this.tabla.filterGlobal( this.busqueda, 'contains' );
    }, 5 );
  }

  onSubmit() {
    this.submitted = true;
    if ( this.formulario.valid ) {
      this.carInformacionInicial = true;
      const registro = this.formulario.value;
      const exiIgual = this.lisHomologacionTodas.find( x => x.idFase == registro.idFase && x.idEstadoShivam == registro.idEstadoShivam && x.idLineaCredito == registro.idLineaCredito );
      if ( exiIgual && exiIgual.indicadorHabilitado ) {
        this.navServicio.setMesage( 4, {
          severity: 'info', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
          detail: this.navServicio.buscarMensaje( 'HOMOLOGACIONESTADO.MSG_YAEXISTE' )
        } );
        this.carInformacionInicial = false;
        this.filtrar();
      } else if ( exiIgual && !exiIgual.indicadorHabilitado ) {
        exiIgual.indicadorHabilitado = true;
        exiIgual.idEstado = registro.idEstado;
        this.homEstadoServicio.actualizar( exiIgual ).subscribe( actualizado => {
          const estado = this.lisEstados.find( x => x.value == exiIgual.idEstado );
          if ( estado ) {
            exiIgual.estado = estado.label;
          }
          this.salir();
        } );
      } else {
        registro.indicadorHabilitado = true;
        this.homEstadoServicio.crear( registro ).subscribe( creo => {
          registro.idHomologacionEstado = creo.idHomologacionEstado;
          const estado = this.lisEstados.find( x => x.value == registro.idEstado );
          if ( estado ) {
            registro.estado = estado.label;
          }
          const estShivam = this.lisEstadosShivam.find( x => x.value == registro.idEstadoShivam );
          if ( estShivam ) {
            registro.estadoShivam = estShivam.label;
          }
          const fase = this.lisFase.find( x => x.value == registro.idFase );
          if ( fase ) {
            registro.fase = fase.label;
          }
          const linea = this.lisLineaCredito.find( x => x.value == registro.idLineaCredito );
          if ( linea ) {
            registro.lineaCredito = linea.label;
          }
          this.lisHomologacionTodas.push( registro );
          this.salir();
        } );
      }
    }
  }

  salir() {
    this.formulario.reset();
    this.cargarHabilitados();
    this.navServicio.setMesage( 1 );
    this.submitted = false;
    this.carInformacionInicial = false;
    this.filtrar();
  }

  inhabilitar( registro: HomologacionEstado ) {
    this.conServicio.confirm( {
      message: this.navServicio.buscarMensaje( 'MSG_INHABILITAR' ),
      header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
      icon: 'fa fa-question-circle',
      accept: () => {
        this.carInformacionInicial = true;
        registro.indicadorHabilitado = false;
        this.homEstadoServicio.actualizar( registro ).subscribe( regActualizado => {
          this.navServicio.setMesage( 2 );
          this.cargarHabilitados();
          this.carInformacionInicial = false;
          this.filtrar();
        } );
      },
      reject: () => {
      }
    } );
  }

  get f() {
    return this.formulario.controls;
  }

}
